export default function remove(array, item) {
    const index = array.indexOf(item);
    if (index != undefined) {
        array.splice(index, 1);
        return true;
    }
    else {
        return false;
    }
}
